import { css } from '@emotion/css';
import { baseTheme } from '@streamlain/theme';

export const numberStyle = css({
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  color: 'var(--streamlain-v2-text-primary)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  wordBreak: 'break-all',
});

export const numberInputStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  color: 'var(--streamlain-v2-text-primary)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  textAlign: 'right',
  ':focus': {
    outline: 'none',
  },
});
